import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles.scss'

const Comparable = (props) => {
  const {
    campaignComparable: { address, default_image, suburb_name, bedrooms, bathrooms, carparks, price_guide },
  } = props

  return (
    <div className={styles.root}>
      <div className={styles.image} style={{ backgroundImage: default_image ? `url(${default_image})` : null }} />
      <div className={styles.details}>
        <span className={styles.address}>
          {address}, {suburb_name}
        </span>
        <span className={styles.attributes}>
          {bedrooms} bed | {bathrooms} bath | {carparks} car
        </span>
        <span className={styles.price}>{price_guide}</span>
      </div>
    </div>
  )
}

Comparable.propTypes = {
  campaignComparable: PropTypes.object.isRequired,
}

export default Comparable
